<section
	[editableInStoryblok]="_editable()"
	class="section-spacing section-gap-wide px-0"
	data-test-class="feature-split-section"
>
	@for (featureSplit of splits(); track featureSplit._uid; let odd = $odd) {
		<vp-feature-split
			[editableInStoryblok]="featureSplit._editable"
			[images]="featureSplit.photos"
			[inverse]="odd !== startInversed()"
		>
			<header>
				<h3
					class="heading-group heading-group-section heading-group-lg font-display"
				>
					{{ featureSplit.title }}
				</h3>
				<p class="heading-group-overline" role="doc-subtitle">
					{{ featureSplit.overline }}
				</p>
			</header>
			@for (blok of featureSplit.content; track $index) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok.component]"
					[ndcDynamicInputs]="blok"
					class="hidden"
				/>
			}
		</vp-feature-split>
	}
</section>
